export const newBrussels = [
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/29063d32961fc151dbf3bff46b7e5210e8b856220a7726210f42df57.jpg",
    type: "Room",
    available: "From 15 September",
    title: "Rooms for rent in 2-bedroom apartment in Brussels",
    rent: "425 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/619433",
    id: "brussels1"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a5e1a1887a288f58e4ae38da351a8bc1fe770a3913d1a10646b05f24.jpg",
    type: "Room",
    available: "From 1 August",
    title: "Colourful room in 5-bedroom house in Wezembeek-Oppem",
    rent: "450 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/145483",
    id: "brussels2"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/c2be03daaf61acdffe6137412a70a916d63ddb2f3919dc4468fa23a9.jpg",
    type: "Room",
    available: "From 15 August",
    title: "Sunny room in 5-bedroom house in Wezembeek-Oppem",
    rent: "450 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/145481",
    id: "brussels3"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a6ca6a59fb5535e50ccf861c5dcc228550e36ae96e322d36cddfee27.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Bright room in 5-bedroom house in Wezembeek-Oppem",
    rent: "450 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/145482",
    id: "brussels4"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/57cc3b475b387191f6989e07a589e701b4d560674c07b49fe6a74487.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Rooms for rent in 3-bedroom apartment in Anderlecht, Belgium",
    rent: "460 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/307313",
    id: "brussels5"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/29bc322d3cd4917dfee886a4a354854b65f35f621821d98c9adb3977.jpg",
    type: "Room",
    available: "From 3 August",
    title: "Spacious room in 5-bedroom house in Wezembeek-Oppem",
    rent: "470 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/369545",
    id: "brussels6"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/1e6099de75e6178412c640a4b545494a46f86089fdb05e391f8c2ee2.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent in 5-bedroom house in Wezembeek-Oppem",
    rent: "470 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/650940",
    id: "brussels7"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a1858b7faf5d2baa99052dae0fe2d65f739909b6e26bd7b8d83742cd.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent 7-bedroom house in Anderlecht, Brussels",
    rent: "475 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/253946",
    id: "brussels8"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a5b6e3967ce15dd0acadd3cbc021c520eda97110811d9c71b9a54540.jpg",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in 3-bedroom apartment in Evere, Brussels",
    rent: "480 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/564995",
    id: "brussels9"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/acb6a33790b4afbc0ea5e6c100314a55b0c63dc04d46bd28f34c5769.jpg",
    type: "Residence",
    available: "From 1 September",
    title: "Furnished room in apartment in Saint Guidon, Brussels",
    rent: "480 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:residences/160841",
    id: "brussels10"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/acb6a33790b4afbc0ea5e6c100314a55b0c63dc04d46bd28f34c5769.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Furnished room in apartment in Saint Guidon, Brussels",
    rent: "480 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/153095",
    id: "brussels11"
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/bb3e18932bc56b5bb609a78ed0604816ccb4d04a8048a8e06f09f02e.jpg",
    type: "Room",
    available: "From 1 July",
    title: "Room in shared apartment in Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/588685",
    id: "brussels12"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/ba5c3cee90a5c8a6980d83ed42185bf7b0ac7132bc51448568bf7a99.jpg",
    type: "Room",
    available: "From 2 July",
    title: "Intimate room in 6-bedroom apartment in Jette, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/359028",
    id: "brussels13"
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/31cb395fdfee1a55b5c4c99f0a03f2261f01d1bde1a9b2907b2cbbb0.jpg",
    type: "Room",
    available: "From 31 July",
    title: "Room for rent in 6-bedroom apartment in Etterbeek, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/428891",
    id: "brussels14"
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/3c05ac2d305d138545b8668beb27f585ba130043f3a3d78e40fe0f26.jpg",
    type: "Room",
    available: "From 31 July",
    title: "Room for rent in 6-bedroom apartment in Etterbeek, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/428890",
    id: "brussels15"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/5cc54ede4b7417fb2d0e4bf8adc2a0984ac1b1f1b1ad857b86288b08.jpg",
    type: "Room",
    available: "From 1 August",
    title: "Intimate room in 6-bedroom apartment in Jette, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/359024",
    id: "brussels16"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/98fcb40f97ce2ac659bdfd1f009eff3cdf7d39bd634f827b7070eb39.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room in 4-bedroom apartment for rent in Anderlecht, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/205609",
    id: "brussels17"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/cc97396f37a6d7f4825ed938ee20f91a45033d5cce6d5e09c5745dc6.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room in 4-bedroom apartment for rent in Anderlecht, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/205611",
    id: "brussels18"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6a6aea8d7c345c9cbef3ac250a9686fc7788e6f27e5e1eb2c5083fff.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Intimate room in 6-bedroom apartment in Jette, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/359022",
    id: "brussels19"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/d62b7dc7b4e4b53ac6df8250eef33bd08b3995c01cf0d047b211e872.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Sunny room in 6-bedroom apartment in Jette, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/359023",
    id: "brussels20"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 September",
    title: "Intimate room in 6-bedroom apartment in Jette, Brussels",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/359025",
    id: "brussels21"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/b152602dbcb74bf2e41f8459c34fba990d08bdb2b90048d687a6c086.jpg",
    type: "Room",
    available: "From 2 May",
    title: "Cozy room in 7-bedroom apartment in Anderlecht, Brussels",
    rent: "505 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/146147",
    id: "brussels22"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/66bbe83edb22e725554a2d30bd0e58d2985efdbc443731f52440010f.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent 7-bedroom house in Anderlecht, Brussels",
    rent: "505 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/253947",
    id: "brussels23"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/4a8c6f66e521f4262b34b9dba4f28d0d1dd092db55d8fbcf126254e3.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent 7-bedroom house in Anderlecht, Brussels",
    rent: "505 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/253945",
    id: "brussels24"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/347a3ae81fb74a8cef84beb54c0c52a71d48f2649cf6cab4a121a43c.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Sunny room in 7-bedroom apartment in Anderlecht, Brussels",
    rent: "505 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/164646",
    id: "brussels25"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6fcb3b1c1c0dc47b4f72df8492aa85fea703fcf0b8aa77f4b5fe8931.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Warm room in 7-bedroom apartment in Anderlecht, Brussels",
    rent: "505 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/146146",
    id: "brussels26"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/9a6b99eb8d266e1e695830426f3c736c355058419a9d1c558a690ed0.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room in 7-bedroom apartment in Anderlecht, Brussels",
    rent: "520 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/594398",
    id: "brussels27"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Ample room in apartment in Forest, Brussels",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/120823",
    id: "brussels28"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in 2-bedroom apartment in Brussels",
    rent: "560 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/605685",
    id: "brussels29"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 20 June",
    title: "Intimate room in apartment in Saint-Stevens-Woluwe, Brussels",
    rent: "580 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/95661",
    id: "brussels30"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Cozy room in apartment in Saint-Stevens-Woluwe, Brussels",
    rent: "580 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/125966",
    id: "brussels31"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Interior room in apartment in Saint-Stevens-Woluwe, Brussels",
    rent: "580 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/95662",
    id: "brussels32"
  },
  {
    type: "Studio",
    available: "From 1 September",
    title: "Studio apartment for rent in Anderlecht, Brussels",
    rent: "580 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:studios/593419",
    id: "brussels33"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 September",
    title: "Cosy room for rent in 2-bedroom apartment, Schaerbeek",
    rent: "580 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/302296",
    id: "brussels34"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 10 July",
    title: "Cosy room in 5-bedroom house in Laeken. Brussels",
    rent: "585 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/269500",
    id: "brussels35"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Big room in 2-bedroom apartment in Jasofat, Brussels",
    rent: "585 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/127078",
    id: "brussels36"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Rooms for rent in 3-bedroom apartment in Brussels",
    rent: "590 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/592445",
    id: "brussels37"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 September",
    title: "Cosy room for rent in 4-bedroom  house in Saint Lambert",
    rent: "595 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/377489",
    id: "brussels38"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 September",
    title: "Cheerful room for rent in 4-bedroom house in Saint Lambert",
    rent: "595 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/377488",
    id: "brussels39"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Rooms for rent in 5-bedroom house in Schaerbeek, Brussels",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/152647",
    id: "brussels40"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in 5-bedroom house in Schaerbeek, Brussels",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/393670",
    id: "brussels41"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 12 September",
    title: "Room for rent in 5-bedroom house in Schaerbeek, Brussels",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/393669",
    id: "brussels42"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 26 September",
    title: "Room for rent in 6-bedroom apartment in Etterbeek, Brussels",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/448802",
    id: "brussels43"
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 June",
    title: "Studio apartment for rent in Woluwe Saint Lambert, Brussels",
    rent: "610 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:studios/289384",
    id: "brussels44"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 26 September",
    title: "Huge room in apartment in Saint-Stevens-Woluwe, Brussels",
    rent: "610 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/125967",
    id: "brussels45"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 May",
    title: "Room for rent in 2-bedroom apartment in Auderghem, Brussels",
    rent: "630 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/299636",
    id: "brussels46"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 September",
    title: "Decorated room in 4-bedroom apartment in Ixelles, Brussels",
    rent: "640 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/128334",
    id: "brussels47"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Toasty room for rent in 2-bedroom apartment in Schaerbeek",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/383725",
    id: "brussels48"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 June",
    title: "Rooms for rent in 5-bedroom house in Schaerbeek, Brussels",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/153408",
    id: "brussels49"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Room for rent in 4-bedroom apartment in Saint-Gilles",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/352902",
    id: "brussels50"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 August",
    title: "19-bedroom house for rent in Brussels",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/636592",
    id: "brussels51"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Big double room in 6-bedroom apartment in Jette, Brussels",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/410467",
    id: "brussels52"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Huge room in apartment in Etterbeek, Brussels",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/113406",
    id: "brussels53"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 29 June",
    title: "Rooms for rent in 3-bedroom house in Evere, Brussels",
    rent: "660 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/640976",
    id: "brussels54"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 4 July",
    title: "Spacious room in 4-bedroom house in Etterbeek, Brussels",
    rent: "660 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/202751",
    id: "brussels55"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in Châtelain, Brussels",
    rent: "670 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/635515",
    id: "brussels56"
  },
  {
    type: "Studio",
    available: "From 1 September",
    title: "Studio in Anderlecht",
    rent: "670 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:studios/388574",
    id: "brussels57"
  },
  {
    type: "Room",
    available: "From 1 August",
    title: "Room in shared apartment in Watermael-Boitsfort",
    rent: "680 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/636036",
    id: "brussels58"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Charming room for rent in Châtelain, Brussels",
    rent: "680 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/309965",
    id: "brussels59"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 July",
    title: "Bright room in 8-bedroom apartment in Schuman, Brussels",
    rent: "690 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/brussels/for-rent:rooms/130721",
    id: "brussels60"
  }
];
